module.exports = __webpack_public_path__ + "static/media/eg.d92e3407.jpg";